// Does the body pull in remote resources (tracking pixels, hosted images/CSS)?
export function hasRemoteContent(html: string): boolean {
  return (
    /(?:src|href|background)\s*=\s*["']?https?:\/\//i.test(html) || /url\(\s*["']?https?:/i.test(html)
  );
}

// CSP injected into the reading-pane iframe. Blocked: only inline styles +
// data: images render. Loaded: https images/styles/fonts allowed. Scripts and
// frames are never permitted (the iframe also has no allow-scripts).
export function bodyDoc(html: string, loadRemote: boolean): string {
  const csp = loadRemote
    ? "default-src 'none'; style-src 'unsafe-inline' https: data:; img-src https: data:; font-src https: data:; media-src https: data:"
    : "default-src 'none'; style-src 'unsafe-inline' data:; img-src data:; font-src data:";
  return `<meta http-equiv="Content-Security-Policy" content="${csp}"><base target="_blank">${html}`;
}
